module.exports = __webpack_public_path__ + "static/media/maintenance-icon.1462e608.svg";